module.exports = __webpack_public_path__ + "static/media/Sopachoisam.3ebd2fe6.jpg";